import { useState } from "react";
import "./Withdrawal.css";
import Loader from './../../../../utils/Loader/Loader';
const getToday = () => {
  return new Date().toISOString().split("T")[0];
};
const Withdrawal = ({
  selectedPartner,
  stats,
  onAddWithdrawal,
  showToast
}) => {
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState(getToday());
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (selectedPartner.id === "all") return null;
  const handleSubmit = async () => {

  const numAmount = Number(amount);

  if (!numAmount || !date) {
    showToast("Enter amount and date", "error");
    return;
  }

  if (numAmount > stats.availableBalance) {
    showToast("Withdrawal exceeds available balance", "error");
    return;
  }

  try {

    setIsSubmitting(true);

    await onAddWithdrawal({
      partnerId: selectedPartner.id,
      name: selectedPartner.name,
      amount: numAmount,
      date
    });

    setAmount("");
    setDate(getToday());

  } catch (err) {

    console.error(err);

  } finally {

    setIsSubmitting(false);
  }
};

  return (
    <div className="withdrawal">
      {isSubmitting && (
  <Loader text="Adding withdrawal..." />
)}
      <h3>Withdraw ({selectedPartner.name})</h3>

      <div className="withdrawal-form">
        <input
          type="number"
          placeholder="Amount"
          value={amount}
          onChange={e => setAmount(e.target.value)}
        />

        <input
  type="date"
  value={date}
  onChange={e => setDate(e.target.value)}
  max={getToday()}
/>

        <button
  onClick={handleSubmit}
  disabled={isSubmitting}
>
  {isSubmitting ? "Adding..." : "Add"}
</button>
      </div>

      <div className="withdrawal-info">
        <p>Total Profit: {stats?.netProfitLoss}</p>
        <p>Withdrawn: {stats?.totalWithdrawn}</p>
        <p>Balance: {stats?.availableBalance}</p>
      </div>
    </div>
  );
};

export default Withdrawal;